<div class="content mt-3">
    <div class="container">
        <div class="row" *ngIf="!dataLoaded"><i class="fa fa-spin fa-spinner"></i></div>
        <div class="row" *ngIf="dataLoaded">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header cardheader">
                        <div class="col-12">
                            <h1 class="heading">One Stop Solution</h1>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-md-3 col-sm-3 col-12">
                                    <button type="button" (click)="sethelpData(titledata.title)"
                                        class="btn btn-outline-info btn-block btn-flat"
                                        *ngFor="let titledata of allTitle">
                                        {{titledata.title}}
                                    </button>
                                    <button type="button" class="btn btn-outline-info btn-block btn-flat"
                                        routerLink="/doctors">
                                        Doctor List
                                    </button>
                                    <button type="button" class="btn btn-outline-info btn-block btn-flat"
                                        routerLink="/hospitals">
                                        Hospital List
                                    </button>
                                </div>
                                <div class="col-md-9 col-sm-9 col-12">
                                    <div *ngFor="let data of helpData">
                                        <h1 class="text-center"><b><u>{{data.title}}</u></b></h1>
                                        <div class="panel-body" [innerHtml]='data.description'>
                                            <!-- description -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <tr *ngIf="!treatCategory.length">
                        <td colspan="5"><i class="far fa-frown"></i> Data not found</td>
                    </tr>
                </div>
            </div>
        </div>
    </div>
</div>